export { default } from '@/features/settings/pages/NewPrinterPage'
